import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLang } from "../../context/LanguageContext";
import { RiErrorWarningLine } from "react-icons/ri";
import { MdOutlineArrowForward } from "react-icons/md";

const TRANSLATIONS = {
  EN: {
    code: "404",
    title: "Page Not Found",
    description: "The page you are looking for doesn't exist, has been removed, or is temporarily unavailable.",
    button: "Go to User Admin",
    autoRedirect: "Redirecting in",
    seconds: "seconds",
  },
  ES: {
    code: "404",
    title: "Página No Encontrada",
    description: "La página que buscas no existe, ha sido eliminada o no está disponible temporalmente.",
    button: "Ir a Administración de Usuarios",
    autoRedirect: "Redirigiendo en",
    seconds: "segundos",
  },
};

const NotFound = () => {
  const navigate = useNavigate();
  const { lang } = useLang();
  const t = TRANSLATIONS[lang] || TRANSLATIONS.EN;
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate("/user-admin", { replace: true });
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className="flex flex-col w-full h-full items-center justify-center p-6 text-center select-none overflow-y-auto">
      <div className="max-w-md w-full flex flex-col items-center gap-5 p-8 rounded-3xl bg-gradient-to-b from-[#F0EEF8]/60 via-white to-[#F0EEF8]/40 border border-primary/15 shadow-lg">
        
        {/* Graphic Badge */}
        <div className="relative flex items-center justify-center">
          <div className="w-24 h-24 rounded-3xl bg-primary/10 flex items-center justify-center text-primary shadow-sm border border-primary/20">
            <RiErrorWarningLine className="text-6xl text-primary animate-pulse" />
          </div>
          <span className="absolute -top-2 -right-2 px-3 py-1 rounded-full bg-primary text-white font-roboto font-black text-xs shadow-md tracking-wider">
            {t.code}
          </span>
        </div>

        {/* Headings */}
        <div className="flex flex-col gap-2">
          <h1 className="font-roboto font-bold text-2xl text-primary uppercase tracking-wide">
            {t.title}
          </h1>
          <p className="font-roboto text-sm text-gray-500 leading-relaxed">
            {t.description}
          </p>
        </div>

        {/* Auto Redirect Countdown Info */}
        <div className="px-4 py-2 rounded-xl bg-[#F0EEF8] border border-primary/10 text-xs font-roboto text-gray-600">
          <span>{t.autoRedirect} </span>
          <span className="font-bold text-primary font-mono">{countdown}</span>
          <span> {t.seconds}...</span>
        </div>

        {/* Action Button */}
        <button
          onClick={() => navigate("/user-admin", { replace: true })}
          className="w-full py-3 px-6 rounded-xl font-roboto font-bold text-sm text-white bg-primary hover:bg-primary/90 transition-all uppercase tracking-wide shadow-md hover:shadow-lg flex items-center justify-center gap-2 group cursor-pointer"
        >
          <span>{t.button}</span>
          <MdOutlineArrowForward className="text-lg transition-transform group-hover:translate-x-1" />
        </button>
      </div>
    </div>
  );
};

export default NotFound;
